import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { ADLNeedQuestionnaireItem } from './questionnaire'

export const ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [ADLNeedQuestionnaireItem.ADL_NEEDS]: QuestionnaireAnswerType.GROUP,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED]: QuestionnaireAnswerType.GROUP,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_ID]: QuestionnaireAnswerType.STRING,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_OBSERVATION_REFERENCE]:
    QuestionnaireAnswerType.REFERENCE,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_NAME]: QuestionnaireAnswerType.STRING,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_NEW_NOTE]: QuestionnaireAnswerType.STRING,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_IS_ARCHIVED]: QuestionnaireAnswerType.BOOLEAN,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_AUTHOR]: QuestionnaireAnswerType.STRING,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_DATE]: QuestionnaireAnswerType.DATE,
  [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_TEXT]: QuestionnaireAnswerType.STRING
}
